// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"15854f00","513":"1e8de24a","703":"58fe9295","787":"57a6ad32"}[chunkId] + ".chunk.js";
};